import { render, staticRenderFns } from "./FilterHighlight.vue?vue&type=template&id=1f3d053a&scoped=true"
import script from "./FilterHighlight.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterHighlight.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FilterHighlight.vue?vue&type=style&index=0&id=1f3d053a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d053a",
  null
  
)

export default component.exports